export default {
  modals: {
    questionnaire: {
      greeting: {
        title: 'Welcome to edna Pulse, {{name}}!',
        description:
          'Tell us a bit about yourself – it will help us improve the product in the right direction',
      },
      skip: 'Skip',
      emptyError: 'Please select a value',
      job: {
        title: 'Which industry are you working in?',
        medicine: 'Healthcare',
        education: 'Education',
        groceries: 'Retail',
        realEstate: 'Real estate',
        services: 'Service industry',
        auto: 'Automotive',
        other: 'Other, up to 50 characters',
      },
      role: {
        title: 'What is your role in the company?',
        marketing: 'Marketer',
        salesManager: 'Sales manager',
        analytic: 'Analyst',
        developer: 'IT specialist',
        businessOwner: 'Manager / Business owner',
        accountant: 'Accountant',
        other: 'Other, up to 50 characters',
      },
      goals: {
        title: 'What tasks will you handle in your account?',
        broadcasts: 'set up and send broadcasts',
        bills: ' pay invoices, plan communication budgets',
        broadcastsAnalytics: 'analyze broadcast performance',
        api: 'set up and maintain API integration',
        other: 'Other, up to 150 characters',
      },
      people: {
        title: 'How many people work in your company?',
        ten: 'Up to 10',
        hundred: '10 - 100',
        thousand: '100 - 1000',
        moreThanThousand: 'More than 1000',
      },
      opinion: {
        title: 'Would you like to share your feedback?',
        description:
          'From time to time we would like to hear your opinion about the product. Would you be willing to take part in our surveys?',
        yes: 'Yes, sure',
        no: 'No, thanks',
      },
      success: {
        title: 'Thank you very much for your participation!',
        toProfile: 'Go to my account',
      },
    },
  },
};
